import { useEffect } from 'react';
import useRequest from './useRequest';

export interface CheckRequestIdData {
  RequestId: string;
  fromHistory?: boolean;
}

// eslint-disable-next-line no-shadow
export enum RequestStatusCode {
  Approvable = '1',
  Invalid = '2',
  Exists = '3',
}

interface CheckRequestId {
  result: boolean;
  resultCode: RequestStatusCode;
  error: string;
  comment: string;
  requestCode: string;
  reqIdentification: string;
  assignerName: string;
  assignerCode: string;
  supplierName: string;
  supplierCode: string;
  reqAmount: string;
  reqMeasure: string;
  reqDate: string;
  deliveryDate: string;
  reqSupplierName: string;
  templateCount: string;
}

interface CheckRequestIdOptions {
  skip?: boolean;
}

function useCheckRequestId(data: CheckRequestIdData, options?: CheckRequestIdOptions) {
  const { RequestId } = data;
  const { skip = false } = options || {};
  const [_, result] = useRequest<CheckRequestId>('CheckRequestId', {
    params: `RequestId=${RequestId}`,
    skip,
  });

  return result;
}

export default useCheckRequestId;
